module.exports = __webpack_public_path__ + "img/KayakChile-logo.214210df.jpg";